import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import DeleteIcon from '@mui/icons-material/Delete';
import { styled } from '@mui/material/styles';
import { Button } from 'react-admin';

const StyledButton = styled(Button)(({ theme }) => ({
    color: theme?.palette?.error?.main || '#d32f2f',
}));

const RemoveVideoButton = (props) => {
    const { video, onRemove } = props;

    const handleClick = useCallback(() => {
        onRemove(video);
    }, [onRemove, video]);

    return (
        <StyledButton
            label="Remove video"
            onClick={handleClick}
        >
            <DeleteIcon />
        </StyledButton>
    );
};

RemoveVideoButton.propTypes = {
    video: PropTypes.object.isRequired,
    onRemove: PropTypes.func.isRequired,
};

export default RemoveVideoButton;
